// extracted by mini-css-extract-plugin
module.exports = {"container":"Preloader_container__3xfid","preloader":"Preloader_preloader__2iAGJ"};